(function () {
  if (window.__mmCarousels) return;
  window.__mmCarousels = true;
  window.__splideInstances = window.__splideInstances || {};
  function initializeCarousels() {
    const carouselContainers = document.querySelectorAll('.splide.carousel-container');
    carouselContainers.forEach(container => {
      const carouselId = container.getAttribute('data-carousel-id');
      if (window.__splideInstances[carouselId]) {
        try {
          window.__splideInstances[carouselId].destroy(true);
        } catch (e) {
        }
        delete window.__splideInstances[carouselId];
      }
      const dynamicItemsData = container.getAttribute('data-dynamic-items');
      const slidesList = container.querySelector('.splide__list');
      const showVendor = container.getAttribute('data-show-vendor') === 'true';
      const showPrice = container.getAttribute('data-show-price') === 'true';
      if (dynamicItemsData && slidesList) {
        try {
          const items = JSON.parse(dynamicItemsData);
          slidesList.innerHTML = '';
          items.forEach(item => {
            const slide = document.createElement('li');
            slide.className = 'splide__slide';
            if (item.type === 'product') {
              slide.innerHTML = `
                <div class="carousel-product-item bg-white rounded-lg shadow-sm overflow-hidden">
                  <a href="${item.url}" class="block group">
                    ${item.image ? `
                      <div class="aspect-square overflow-hidden">
                        <img src="${item.image}" alt="${item.title}" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy">
                      </div>
                    ` : ''}
                    <div class="product-info p-4">
                      <h3 class="product-title font-medium text-sm mb-2 line-clamp-2">${item.title}</h3>
                      ${showVendor && item.vendor ? `<p class="product-vendor text-xs text-gray-500 mb-1">${item.vendor}</p>` : ''}
                      ${showPrice && item.price ? `<p class="product-price font-semibold text-sm">${item.price}</p>` : ''}
                    </div>
                  </a>
                </div>
              `;
            } else if (item.type === 'metaobject') {
              slide.innerHTML = `
                <div class="carousel-metaobject-item bg-white rounded-lg shadow-sm overflow-hidden">
                  <a href="${item.url}" class="block group">
                    ${item.image ? `
                      <div class="w-full overflow-hidden">
                        <img src="${item.image}" alt="${item.title}" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy">
                      </div>
                    ` : ''}
                    <div class="item-info p-4">
                      <p class="item-title b6--medium mb-2 line-clamp-2">${item.title}</p>
                      ${item.vendor ? `<p class="product-vendor b6--medium  mb-1">${item.vendor}</p>` : ''}
                      ${item.price ? `<p class="product-price b6--medium ">${item.price}</p>` : ''}
                    </div>
                  </a>
                </div>
              `;
            }
            slidesList.appendChild(slide);
          });
        } catch (e) {
          console.error('Failed to parse dynamic carousel items:', e);
        }
      } else if (slidesList) {
        const childNodes = Array.from(slidesList.children);
        childNodes.forEach(child => {
          if (child.nodeType === Node.ELEMENT_NODE) {
            child.classList.add('splide__slide');
          }
        });
      }

      const splideOptions = container.getAttribute('data-splide');
      let options = {};
      try {
        options = splideOptions ? JSON.parse(splideOptions.replace(/'/g, '"')) : {};
      } catch (e) {
        options = {};
      }

      const scrollType = container.getAttribute('data-autoscroll-type') || 'snap';
      const isAutoplayEnabled = container.getAttribute('data-autoplay') === 'true';
      const autoscrollSpeed = parseInt(container.getAttribute('data-autoscroll-speed')) || 2;

      let extensions = {};
      
      if (isAutoplayEnabled && scrollType === 'linear' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        options.autoScroll = { speed: autoscrollSpeed, pauseOnHover: options.pauseOnHover !== undefined ? options.pauseOnHover : true };
        extensions = { AutoScroll: window.splide.Extensions.AutoScroll };
      }

      const splide = new Splide(container, options);
      const unfocusClones = function () {
        const focusable = 'a, button, input, select, textarea, [tabindex]';
        container.querySelectorAll('.splide__slide').forEach(function (slide) {
          const hidden = slide.classList.contains('splide__slide--clone') || slide.getAttribute('aria-hidden') === 'true';
          slide.querySelectorAll(focusable).forEach(function (el) {
            if (hidden) {
              if (!el.hasAttribute('data-mm-untab')) el.setAttribute('data-mm-untab', el.getAttribute('tabindex') || '');
              el.setAttribute('tabindex', '-1');
            } else if (el.hasAttribute('data-mm-untab')) {
              const was = el.getAttribute('data-mm-untab');
              if (was) el.setAttribute('tabindex', was); else el.removeAttribute('tabindex');
              el.removeAttribute('data-mm-untab');
            }
          });
        });
      };
      splide.on('mounted refresh updated moved visible hidden', unfocusClones);
      splide.mount(extensions);
      unfocusClones();
      if (window.MutationObserver) {
        let unfocusQueued = false;
        if (container.__mmUnfocusObserver) container.__mmUnfocusObserver.disconnect();
        container.__mmUnfocusObserver = new MutationObserver(function () {
          if (unfocusQueued) return;
          unfocusQueued = true;
          requestAnimationFrame(function () { unfocusQueued = false; unfocusClones(); });
        });
        container.__mmUnfocusObserver.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
      }

      const progressBar = container.querySelector('.carousel-progress-bar');
      if (progressBar) {
        const slidesPerPage = splide.options.perPage || 1;

        splide.on('moved', function() {
          const progress = ((splide.index + slidesPerPage) / splide.length) * 100;
          progressBar.style.width = progress + '%';
        });
        
        const initialProgress = ((splide.index + slidesPerPage) / splide.length) * 100;
        progressBar.style.width = initialProgress + '%';
      }

      const showScrollbar = container.getAttribute('data-show-scrollbar') === 'true';
      const scrollbar = container.querySelector('.carousel-scrollbar');
      const scrollbarThumb = container.querySelector('.carousel-scrollbar-thumb');
      
      if (showScrollbar && scrollbar && scrollbarThumb) {
        let scrollTimeout;
        let isAnimating = false;
        let isDragging = false;
        let dragStartX = 0;
        let scrollStartPosition = 0;
        let currentScrollPosition = 0;
        
        function updateScrollbar(position = null, forceSmooth = false) {
          const slidesPerPage = splide.options.perPage || 1;
          const totalSlides = splide.length;
          
          let scrollPosition;
          if (position !== null) {
            scrollPosition = position;
          } else {
            const maxIndex = Math.max(0, totalSlides - slidesPerPage);
            scrollPosition = maxIndex > 0 ? splide.index / maxIndex : 0;
          }
          
          const clampedPosition = Math.max(0, Math.min(1, scrollPosition));
          currentScrollPosition = scrollPosition;
          
          const thumbWidth = Math.max(10, (slidesPerPage / totalSlides) * 100);
          
          let thumbPosition = clampedPosition * (100 - thumbWidth);
          
          if (forceSmooth && !isDragging) {
            scrollbarThumb.style.transition = 'width 0.2s cubic-bezier(0.4, 0, 0.2, 1), transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)';
            setTimeout(() => {
              if (scrollbarThumb) {
                scrollbarThumb.style.transition = 'width 0.1s cubic-bezier(0.4, 0, 0.2, 1)';
              }
            }, 200);
          }
          
          if (scrollPosition < 0 && isDragging) {
            const overscroll = Math.abs(scrollPosition);
            const compression = Math.min(0.5, overscroll * 2);
            thumbPosition = 0;
            scrollbarThumb.style.width = (thumbWidth * (1 - compression)) + '%';
            scrollbarThumb.style.left = '0%';
            scrollbarThumb.style.transform = `scaleX(${1 - compression * 0.5})`;
          } else if (scrollPosition > 1 && isDragging) {
            const overscroll = scrollPosition - 1;
            const compression = Math.min(0.5, overscroll * 2);
            thumbPosition = 100 - thumbWidth;
            scrollbarThumb.style.width = (thumbWidth * (1 - compression)) + '%';
            scrollbarThumb.style.left = thumbPosition + '%';
            scrollbarThumb.style.transform = `scaleX(${1 - compression * 0.5})`;
          } else {
            scrollbarThumb.style.width = thumbWidth + '%';
            scrollbarThumb.style.left = thumbPosition + '%';
            scrollbarThumb.style.transform = 'none';
          }
        }
        
        function updateScrollbarSmooth(position = null, forceSmooth = false) {
          if (!isAnimating) {
            isAnimating = true;
            requestAnimationFrame(() => {
              updateScrollbar(position, forceSmooth);
              isAnimating = false;
            });
          }
        }
        
        function calculateDragPosition(currentX) {
          const track = container.querySelector('.splide__track');
          if (!track) return currentScrollPosition;
          
          const trackWidth = track.offsetWidth;
          const dragDistance = currentX - dragStartX;
          const dragRatio = dragDistance / trackWidth;
          
          const sensitivity = 0.8;
          const newPosition = scrollStartPosition - (dragRatio * sensitivity);
          
          const smoothingFactor = 0.1;
          const smoothedPosition = currentScrollPosition + (newPosition - currentScrollPosition) * smoothingFactor;
          
          return smoothedPosition;
        }
        
        function showScrollbar() {
          scrollbar.classList.add('visible');
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            scrollbar.classList.remove('visible');
          }, 400);
        }
        
        function showScrollbarImmediate() {
          scrollbar.classList.add('visible');
          clearTimeout(scrollTimeout);
        }
        
        function hideScrollbarDelayed() {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            scrollbar.classList.remove('visible');
          }, 400);
        }
        
        const track = container.querySelector('.splide__track');
        if (track) {
          track.addEventListener('mousedown', function(e) {
            isDragging = true;
            dragStartX = e.clientX;
            scrollStartPosition = currentScrollPosition;
            showScrollbarImmediate();
          });
          
          track.addEventListener('mousemove', function(e) {
            if (e.buttons > 0 && isDragging) {
              showScrollbarImmediate();
              const position = calculateDragPosition(e.clientX);
              updateScrollbarSmooth(position);
            }
          });
          
          track.addEventListener('mouseup', function() {
            isDragging = false;
            hideScrollbarDelayed();
          });
          
          track.addEventListener('touchstart', function(e) {
            isDragging = true;
            dragStartX = e.touches[0].clientX;
            scrollStartPosition = currentScrollPosition;
            showScrollbarImmediate();
          });
          
          track.addEventListener('touchmove', function(e) {
            if (isDragging) {
              showScrollbarImmediate();
              const position = calculateDragPosition(e.touches[0].clientX);
              updateScrollbarSmooth(position);
            }
          });
          
          track.addEventListener('touchend', function() {
            isDragging = false;
            hideScrollbarDelayed();
          });
          
          track.addEventListener('wheel', function() {
            showScrollbarImmediate();
            hideScrollbarDelayed();
          });
        }
        
        splide.on('moved', function() {
          isDragging = false;
          setTimeout(() => {
            updateScrollbarSmooth(null, true);
            showScrollbar();
          }, 50);
        });
        
        splide.on('drag', function() {
          if (!isDragging) {
            isDragging = true;
            dragStartX = 0;
            scrollStartPosition = currentScrollPosition;
          }
          showScrollbarImmediate();
        });
        
        splide.on('dragged', function() {
          isDragging = false;
          setTimeout(() => {
            updateScrollbarSmooth(null, true);
            hideScrollbarDelayed();
          }, 100);
        });
        
        splide.on('scroll', function() {
          showScrollbarImmediate();
        });
        
        splide.on('scrolled', function() {
          setTimeout(() => {
            updateScrollbarSmooth(null, true);
            hideScrollbarDelayed();
          }, 50);
        });
        
        updateScrollbar();
      }

      window.__splideInstances[carouselId] = splide;
    });
    const externalArrows = document.querySelectorAll('[data-carousel-arrows-for]');
    externalArrows.forEach(arrowBlock => {
      const targetCarouselId = arrowBlock.getAttribute('data-carousel-arrows-for');
      if (targetCarouselId && window.__splideInstances[targetCarouselId]) {
        const splideInstance = window.__splideInstances[targetCarouselId];
        const prevButton = arrowBlock.querySelector('.carousel__arrow--prev');
        const nextButton = arrowBlock.querySelector('.carousel__arrow--next');
        if (prevButton && !prevButton.__mmBound) {
          prevButton.__mmBound = true;
          prevButton.addEventListener('click', function() {
            const current = window.__splideInstances[targetCarouselId];
            if (current) current.go('<');
          });
        }
        if (nextButton && !nextButton.__mmBound) {
          nextButton.__mmBound = true;
          nextButton.addEventListener('click', function() {
            const current = window.__splideInstances[targetCarouselId];
            if (current) current.go('>');
          });
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCarousels);
  } else {
    initializeCarousels();
  }

  document.addEventListener('shopify:section:load', initializeCarousels);
})();
